import { CUSTOMER_JOURNEY_ATTRACTIONS } from './../const';

function action(token, lang, context) {
  return { type: CUSTOMER_JOURNEY_ATTRACTIONS, token, lang, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyAttractions.js